import React, { useEffect, useState, useCallback } from "react";
import { connect, useDispatch } from "react-redux";
import { Table } from "@mui/joy";
import { Link, useNavigate } from "react-router-dom";
import {
  delete_buyer,
  delete_user,
  get_buyers,
  get_export_users,
  get_users,
  gotToExport,
  update_user,
} from "../../reduxData/user/userAction";
import GavelIcon from "@mui/icons-material/Gavel";
import { getCountryCallingCode } from "react-phone-number-input";
import { Box, Input } from "@mui/joy";
import CustomPagination from "../CustomPagination";
import EmptyData from "../EmptyData";
import { Token } from "@mui/icons-material";
import { toast } from "react-toastify";
import moment from "moment";
import DeleteContent from "../../Modals/DeleteContent";
import { useSelector } from "react-redux";
import UserDetails from "../UserDetails";
import DeletePopup from "../../Modals/DeletePopup";
import { jsonToCSV, downloadCSV } from "../../utils/DownloadCSV";
import { buyercolumns } from "./utils/Columns";
import FilterModal from "./ReportFilterData";

const BuyerManagement = ({ allUsers, isLoading }) => {
  const [userManagement, setUserManagement] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState(true);
  const [perPage, setPerPage] = useState(10);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");
  const [editData, setEditData] = useState(null);
  const [total, setTotal] = useState(0);
  const [resetPage, setResetPage] = useState(false);
  const [totalUsers, setTotalUsers] = useState("");
  const { user } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [data, setData] = useState(null);
  const { user: userRole } = useSelector((state) => state.auth);
  const [filterModal, setFilterModal] = useState(false);
  const [sortBy, setSortBy] = useState("");

  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [buyerId, setBuyerId] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchData = async (page = currentPage, rows = perPage) => {
    try {
      const data = await get_buyers({ page, rows, email, filter, sortBy });
      setUserManagement(data?.data);
      setTotalUsers(data?.pagination?.total);
      setTotal(data?.total || 0);
      window.scrollTo({ top: 0, behavior: "instant" });
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, perPage, name, email, statusFilter, filter, sortBy]);

  const changeDOJFormat = (data) => {
    const joinDate = moment(data).format("MM/DD/YYYY");
    return joinDate;
  };

  const handleDelete = async (item) => {
    const data = {
      is_deactive: item?.is_deactive ? false : true,
    };
    const message = item?.is_deactive
      ? "User Active Successfully"
      : "User In-Active Successfully";
    const isEdit = await update_user(
      item?.id,
      data,
      navigate,
      localStorage.getItem("token"),
      dispatch,
      true,
      message
    );
    navigate("/buyer");
    if (isEdit) {
      // const data = await get_users(dispatch, localStorage.getItem("token"), currentPage, perPage, "", statusFilter);
      fetchData();
      setUserManagement(data?.data);
    }
  };

  const deleteBuyer = async () => {
    const res = await delete_buyer(buyerId);
    if (res) {
      fetchData();
    }
    setBuyerId("");
    setOpenDeletePopup(false);
  };

  const handleSortBy = useCallback((e) => {
    const value = e.target.value;
    setSortBy(value);
  }, []);

  const handleExportAll = async (startDate, endDate) => {
    try {
      setLoading(true);

      const res = await get_buyers({
        page: 1,
        rows: totalUsers,
        filter,
        startDate,
        endDate,
      });
      const sellers = res?.data || [];
      const csv = jsonToCSV(sellers, buyercolumns);
      downloadCSV(csv, `buyer-management-${Date.now()}.csv`);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <Box className="flex-md-row flex-column gap-2 d-flex mb-3 align-items-md-center justify-content-between">
        <div>
          <h3 className="mb-0 fw-600">Buyer Management</h3>
          <span className="text-muted">
            {totalUsers || 0} {Number(totalUsers) === 1 ? "buyer" : "buyers"}
          </span>
        </div>
      </Box>

      {/* <div
        className="text-decoration-underline ms-2 cursor-pointer mb-3 fs-5 fw-600"
        onClick={() => navigate("/buyer-bid")}
      >
        ( Bids )
      </div> */}
      <div className="users__toolbar mb-3">
        <div className="row g-3 align-items-center">
          <div className="col-lg-4 col-md-6">
            <Input
              id="emailInput"
              type="text"
              placeholder="Email of user"
              value={email}
              onChange={async (e) => {
                setEmail(e.target.value);
                // const data = await get_users(dispatch, localStorage.getItem("token"), 1, 10, name, e.target.value);
                setUserManagement(data?.data);
              }}
            />
          </div>
          <div className="col-lg-8 col-md-6">
            <div className="d-flex flex-wrap gap-2 justify-content-md-end align-items-center ">
              <div className="btn-group gap-2">
                <button
                  className={`seller-pill text-nowrap rounded-pill px-3 py-2 ${
                    filter ? "active" : ""
                  } `}
                  onClick={() => {
                    setFilter((prev) => !prev);
                    // setResetPage(true);
                  }}
                >
                  Email Verified
                </button>

                <button
                  className={`seller-pill text-nowrap rounded-pill px-3 py-2 ${
                    !filter ? "active" : ""
                  } `}
                  onClick={() => {
                    setFilter((prev) => !prev);
                    // setResetPage(true);
                  }}
                >
                  Not Verified
                </button>
                <select
                  className="seller-sort-select"
                  value={sortBy}
                  defaultValue={""}
                  onChange={handleSortBy}
                >
                  <option value="" disabled>
                    Sort By
                  </option>
                  <option value="bids">Bids </option>
                </select>
              </div>
              <button
                className="btn btn-dark px-3"
                disabled={loading}
                onClick={() => setFilterModal(true)}
              >
                Export All
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="filters mb-3">
        <Input
          id="nameInput"
          type="text"
          placeholder="Search by name/email"
          value={name}
          onChange={async (e) => {
            setName(e.target.value);
            const data = await get_users(dispatch, localStorage.getItem("token"), 1, 10, e.target.value);
            setUserManagement(data?.data);
          }}
        />

     
      </div> */}

      <div className="table-responsive">
        <table className="table user-management-table table-hover">
          <thead className="border-gray">
            <th scope="col">Sr. No.</th>
            <th scope="col">Account Id</th>
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            <th scope="col">Role</th>
            {/* <th scope="col">Store Name</th> */}
            <th scope="col">Phone No.</th>
            <th scope="col" className="text-center">
              Date of Joining
            </th>
            {/* <th scope="col" className="text-center">Phone Number</th> */}
            <th scope="col" className="text-center">
              Status
            </th>
            {((user?.role === "staff" && user?.permission?.p_users > 1) ||
              user?.role !== "staff") && (
              <th scope="col" className="text-center">
                Action
              </th>
            )}
          </thead>
          <tbody>
            {Array.isArray(userManagement) && userManagement?.length > 0 ? (
              userManagement?.map((data, index) => (
                <tr key={index}>
                  <td>{index + 1}.</td>
                  <td>{data?.account_id}</td>
                  <td>
                    <div
                      className={
                        data?.user_name ? "w-fit-content hover-underline" : ""
                      }
                      // onClick={() => {
                      //   setShow(true);
                      //   setData(data);
                      // }}
                    >
                      {data?.first_name
                        ? `${data?.first_name || ""} ${data?.last_name || ""}`
                        : `${data?.shipping_addresses?.[0]?.first_name || ""} ${
                            data?.shipping_addresses?.[0]?.last_name || ""
                          }`}
                    </div>
                  </td>
                  <td>{data?.email}</td>
                  <td>{data?.role}</td>
                  {/* <td>
                    {data?.store_name && data?.store_name !== ""
                      ? data?.store_name
                      : "N/A"}
                  </td> */}
                  <td>
                    {data?.shipping_addresses?.[0]?.phoneNumber
                      ? `${
                          data?.shipping_addresses?.[0]?.country &&
                          `+${getCountryCallingCode(
                            data?.shipping_addresses?.[0]?.country
                          )}`
                        } ${data?.shipping_addresses?.[0]?.phoneNumber}`
                      : ""}
                  </td>
                  <td className="text-center">
                    {changeDOJFormat(data.created_at)}
                  </td>
                  {/* <td className="text-center">{data.phoneNumber ? data.phoneNumber : '-'}</td> */}
                  <td className="text-center">
                    <span
                        className={`seller-badge ${
                          data?.is_deactive ? "is-inactive" : "is-active"
                        }`}
                      >
                        {data?.is_deactive ? "In-active" : "Active"}
                      </span>
                  </td>
                  {((user?.role === "staff" && user?.permission?.p_users > 1) ||
                    user?.role !== "staff") && (
                    <td className=" text-center">
                      {/* <button className="btn btn-sm btn-main m-2"> */}
                      {/* <Link
                      className="navbar-brand"
                      to="javascript:void(0)"
                      disabled={isLoading}
                      onClick={() => exportData(data._id)}
                    >
                      <i className="fa fa-download edit"></i>
                    </Link> */}
                      {/* <Link
                      className="navbar-brand mx-2"
                      to={`/editUser/${data.id}`}
                    >
                      <i className="far fa-edit edit"></i>
                    </Link>  */}
                      <div className="d-flex gap-1 align-items-center">
                        {filter && (
                          <span
                            className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                            onClick={() =>
                              navigate(`/buyer-bid?search=${data?.email}`)
                            }
                          >
                            <GavelIcon fontSize="small" />
                            Bids
                            {data?.total_bids != null &&
                              ` (${data?.total_bids}) `}
                          </span>
                        )}

                        {/* {userRole?.role != "store-manager" && (
                          <i
                            className="bi bi-trash text-danger fs-5 cursor-pointer"
                            onClick={(e) =>
                              //  deleteBuyer(data?.id, e)
                              {
                                e.stopPropagation();
                                setBuyerId(data?.id);
                                setOpenDeletePopup(true);
                              }
                            }
                          ></i>
                        )} */}

                        {((user?.role === "staff" &&
                          user?.permission?.p_users > 2) ||
                          user?.role !== "staff") && (
                          <div class="form-check form-switch switch-large">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault"
                              checked={!data?.is_deactive}
                              onChange={() => handleDelete(data)}
                            />
                          </div>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <EmptyData />
            )}
          </tbody>
        </table>
      </div>

      <div className="mt-3">
        {/* {totalUsers > 0 && (
          <CustomPagination
            total={totalUsers}
            onPageChange={(page, perPage) => { get_users(dispatch, localStorage.getItem("token"), page, perPage, "", statusFilter); }}
          />
        )} */}

        {totalUsers > 0 && (
          <CustomPagination
            total={totalUsers}
            onPageChange={(page, perPage) => {
              setCurrentPage(page);
              setPerPage(perPage);
              // get_users(dispatch, localStorage.getItem("token"), page, perPage, name, statusFilter);
            }}
            resetPage={resetPage}
          />
        )}
      </div>

      {openDeletePopup && (
        <DeletePopup
          open={openDeletePopup}
          setOpen={setOpenDeletePopup}
          label="Are you sure ,you want to delete the Buyer"
          handleDelete={deleteBuyer}
        />
      )}

      <UserDetails
        show={show}
        handleClose={() => {
          setData(null);
          setShow(false);
        }}
        user={data}
      />
      <DeleteContent
        show={isDelete}
        handleClose={() => {
          setEditData(null);
          setIsDelete(false);
        }}
        data={editData}
        heading={"User"}
        otherLine={"User"}
        isFaq={"userDelete"}
      />
      {filterModal && (
        <FilterModal
          filterModal={filterModal}
          setFilterModal={setFilterModal}
          handleExportAll={handleExportAll}
        />
      )}
    </div>
  );
};

export default BuyerManagement;
